/* ATHL8: Per-product reviews carousel. Wires prev/next buttons to the track. */
(function () {
  function init(section) {
    var track = section.querySelector('[data-reviews-track]');
    var prev = section.querySelector('[data-reviews-prev]');
    var next = section.querySelector('[data-reviews-next]');
    if (!track || !prev || !next) return;

    function scrollByCard(dir) {
      var card = track.querySelector('.product-reviews__card');
      if (!card) return;
      var gap = parseInt(getComputedStyle(track).gap, 10) || 18;
      var step = card.getBoundingClientRect().width + gap;
      track.scrollBy({ left: step * dir, behavior: 'smooth' });
    }

    function updateButtons() {
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll;
    }

    prev.addEventListener('click', function () { scrollByCard(-1); });
    next.addEventListener('click', function () { scrollByCard(1); });
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  function bootstrap() {
    document.querySelectorAll('.product-reviews').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
